export default "__VITE_ASSET__CF6GIb4Q__"